(function ($) {
    'use strict';
    const keyCodes = {
        Backspace: 8,
        Tab: 9,
        Enter: 13,
        Esc: 27,
        Delete: 46
    };
    $.widget("fd.control_number", {
        options: {
            parentid: null,
            callback: function () { },
            precision: 0,
            allowclear: false,
            min: null,
            max: null
        },
        initial: function (value) {
            if (value === undefined) {
                return this.options.initial;
            }

            this.options.initial = value;
            this.element.data('initial', value).attr('data-initial', value);

            return this;
        },
        _create: function () {
            if (!this.options.parentid) {
                this.options.parentid = this.element.closest('[data-fd-parentid]').data('fd-parentid');
            }

            // Convert numeric options
            this.options.min = this.options.min !== null ? Number(this.options.min) : null;
            this.options.max = this.options.max !== null ? Number(this.options.max) : null;

            this._validate().initial(this.element.val())._setEvents();
        },
        _handleFocus: function (event) {
            const self = event.data;
            self.initial(self.element.val());
        },
        _handleBlur: function (event) {
            const self = event.data;
            self._handleSubmit(event);
        },
        _handleKeypress: function (event) {
            const self = event.data;
            if (event.which === keyCodes.Esc) {
                self.element.val(self.options.initial).focus();
                return;
            }
            if (event.which === keyCodes.Enter) {
                self._handleSubmit(event);
                return;
            }

            if (!String.fromCharCode(event.which).match(/^\-?[0-9]*\.?[0-9]*$/)) {
                event.preventDefault();
                return false;
            }
        },
        _handlePaste: function (event) {
            const self = event.data;
            event.preventDefault();

            let clipboardData = event.originalEvent.clipboardData || window.clipboardData;
            const pastedText = clipboardData.getData('Text');

            self._validate(pastedText);
        },
        _handleSubmit: function (event) {
            this._validate();
            if (Number(this.options.initial) !== Number(this.element.val()) && this.options.callback && typeof (this.options.callback) === 'function') {
                this.options.callback.call(this, { parentid: this.options.parentid, value: this.element.val() }, event);
            }
        },
        _setEvents: function () {
            this.element.off('focus.fdcontrol blur.fdcontrol keyup.fdcontrol paste.fdcontrol')
                .on('focus.fdcontrol', null, this, this._handleFocus)
                .on('blur.fdcontrol', null, this, this._handleBlur)
                .on('keypress.fdcontrol', null, this, this._handleKeypress)
                .on('paste.fdcontrol', null, this, this._handlePaste);
        },
        _setOption: function (key, value) {
            this.options[key] = value;
        },
        _validate: function (newValue) {
            let value;
            if (newValue) {
                value = newValue.replace(/\,/g, '');
            } else {
                value = this.element.val().replace(/\,/g, '');
            }

            if (this.options.allowclear && (value === "" || value === undefined || value === null)) {
                this.element.val(null);
                return this;
            }

            if (!value.match(/^\-?[0-9]*\.?[0-9]*$/)) {
                this.element.val(this.initial());
                return this;
            }
            value = Number(value);

            if (this.options.min !== null && value < Number(this.options.min)) {
                value = Number(this.options.min);
            } else if (this.options.max !== null && value > Number(this.options.max)) {
                value = Number(this.options.max);
            }

            if (this.options.precision !== undefined) {
                this.element.val(value.toFixed(this.options.precision));
            } else {
                this.element.val(value);
            }

            return this;
        }
    });
}(jQuery));